// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.phone-modal__code-select .sk-select__list {\n  top: auto;\n  bottom: 100%;\n  max-height: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
